<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Entrôpot</h4>
            <h6>Gérer vos Entrôpots</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="PDF"
              @click.prevent="exportPDF"
              ><img src="@/assets/img/icons/pdf.svg" alt="img"
            /></a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Excel"
              @click.prevent="exportCSV"
              ><img src="@/assets/img/icons/excel.svg" alt="img"
            /></a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Imprimer"
              @click.prevent="printTable"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Rafraîchir"
              @click.prevent="refreshList"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            data-bs-toggle="modal"
            data-bs-target="#add-units"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Ajouter
            un nouveau Entrôpot</a
          >
        </div>
      </div>
      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input
                  type="text"
                  placeholder="Recherche"
                  class="dark-input"
                  v-model="searchQuery"
                />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <!-- /Filter removed -->
          <div class="table-responsive">
            <a-table
              class="table datanew"
              :columns="columns"
              :data-source="filteredData"
              :row-selection="{}"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-units"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <warehouse-modal
    @warehouse-added="onWarehouseAdded"
    :data="selectedWarehouse"
    @warehouse-updated="onWarehouseUpdate"
  ></warehouse-modal>
</template>
<script>
import { getWarehouseData, deleteWarehouse } from "@/services/productsService";
import { toast } from "vue3-toastify";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCompanyLogoDataUrl } from "@/services/companyService";
const columns = [
  {
    title: "Entrôpot",
    dataIndex: "Warehouse",
    sorter: {
      compare: (a, b) => {
        a = a.Warehouse.toLowerCase();
        b = b.Warehouse.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Adresse",
    dataIndex: "address",
    key: "ContactPerson",
    sorter: {
      compare: (a, b) => String(a.address || "").localeCompare(String(b.address || "")),
    },
  },
  {
    title: "Date de Création",
    dataIndex: "CreatedOn",
    sorter: {
      compare: (a, b) => String(a.CreatedOn || "").localeCompare(String(b.CreatedOn || "")),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
export default {
  data() {
    return {
      searchQuery: "",
      data,
      columns,
      selectedWarehouse: {},
      filteredData: [],
    };
  },

  methods: {
    refreshList() {
      this.getWarehouseData();
    },
    async exportPDF() {
      const rows = this.data;
      if (!rows || !rows.length) return;
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26;
      const margin = 12;
      let dataUrl = null;
      try { dataUrl = await getCompanyLogoDataUrl('logo'); } catch (e) { /* ignore logo load */ }
      const drawHeader = () => {
        if (!dataUrl) return;
        const logoW = 42, logoH = 16;
        const x = (pageWidth - logoW) / 2;
        const y = 8;
        try {
          const fmt = dataUrl.startsWith('data:image/png') ? 'PNG' : 'JPEG';
          doc.addImage(dataUrl, fmt, x, y, logoW, logoH);
        } catch (_) { /* ignore addImage */ }
      };
      const body = rows.map(r => [
        r.Warehouse || '-',
        r.address || '-',
        r.CreatedOn || '-'
      ]);
      autoTable(doc, {
        startY: headerHeight,
        head: [[ 'Entrôpot', 'Adresse', 'Date de Création' ]],
        body,
        headStyles: { fillColor: [30,104,163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 110 }, 2: { cellWidth: 35, halign: 'center' } },
        alternateRowStyles: { fillColor: [245,245,245] },
        didDrawPage: () => {
          drawHeader();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9);
          doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: headerHeight + 4, bottom: 15 }
      });
      doc.save(`entrepots_${new Date().toISOString().slice(0,10)}.pdf`);
    },
    exportCSV() {
      const rows = this.data || [];
      const headers = [ 'Entrôpot', 'Adresse', 'Date de Création' ];
      const csv = [
        headers.join(','),
        ...rows.map(r => [r.Warehouse||'', r.address||'', r.CreatedOn||''].map(v => `"${String(v).replace(/"/g,'""')}"`).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `entrepots_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    printTable() {
      const rows = this.data || [];
      const win = window.open('', '_blank');
      const html = `
        <html><head><title>Liste des Entrôpots</title>
        <style>table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>
        </head><body>
        <h3>Liste des Entrôpots</h3>
        <table>
          <thead>
            <tr><th>Entrôpot</th><th>Adresse</th><th>Date de Création</th></tr>
          </thead>
          <tbody>
            ${rows.map(r => `<tr><td>${r.Warehouse||''}</td><td>${r.address||''}</td><td>${r.CreatedOn||''}</td></tr>`).join('')}
          </tbody>
        </table>
        </body></html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch(e){ /* ignore */ } }, 100);
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer cet entrepôt ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteWarehouse(id);
            if (localStorage.getItem("warehouses") != null) {
              let warehouses = JSON.parse(localStorage.getItem("warehouses"));
              warehouses = warehouses.filter((item) => item.id !== id);
              const jsonData = JSON.stringify(warehouses);
              localStorage.setItem("warehouses", jsonData);
            }

            this.data = this.data.filter((item) => item.id !== id);
            this.applyFilters();
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Le stock a été supprimer.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    async getWarehouseData() {
      this.data = [];
      if (localStorage.getItem("warehouses") != null) {
        const data = JSON.parse(localStorage.getItem("warehouses"));
        data.map((m) => {
          this.data.push({
            id: m.id,
            Warehouse: m.nom,
            address: m.adresse,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } else {
        try {
          const data = await getWarehouseData();
          data.map((m) => {
            this.data.push({
              id: m.id,
              Warehouse: m.nom,
              address: m.adresse,
              CreatedOn: this.formatDate(m.created_at),
            });
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
      // initialize filtered data for search
      this.filteredData = [...this.data];
    },
    applyFilters() {
      const q = (this.searchQuery || '').toLowerCase().trim();
      if (!q) {
        this.filteredData = [...this.data];
        return;
      }
      this.filteredData = this.data.filter((r) =>
        [r.Warehouse, r.address, r.CreatedOn]
          .filter(Boolean)
          .map((v) => v.toString().toLowerCase())
          .some((v) => v.includes(q))
      );
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    onWarehouseAdded(warehouse) {
      const today = new Date();
      if (localStorage.getItem("warehouses") != null) {
        let warehouses = JSON.parse(localStorage.getItem("warehouses"));
        warehouses.push({
          id: warehouse.id,
          nom: warehouse.nom,
          adresse: warehouse.adresse,
          created_at: today.toISOString(),
        });
        const jsonData = JSON.stringify(warehouses);
        localStorage.setItem("warehouses", jsonData);
      }

      this.data.push({
        id: warehouse.id,
        Warehouse: warehouse.nom,
        address: warehouse.adresse,
        CreatedOn: today.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        }),
      });
      this.applyFilters();

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Entrepôt créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    onWarehouseUpdate(warehouse) {
      if (localStorage.getItem("warehouses") != null) {
        let warehouses = JSON.parse(localStorage.getItem("warehouses"));
        warehouses.map((m) => {
          if (m.id == warehouse.id) {
            (m.nom = warehouse.nom), (m.adresse = warehouse.adresse);
          }
        });
        const jsonData = JSON.stringify(warehouses);
        localStorage.setItem("warehouses", jsonData);
      }

      this.data.map((m) => {
        if (m.id == warehouse.id) {
          (m.Warehouse = warehouse.nom), (m.address = warehouse.adresse);
        }
      });
      this.applyFilters();

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Entrepôt modifié avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    openEditModal(item) {
      this.selectedWarehouse = item;
    },
  },
  mounted() {
    this.getWarehouseData();
  },
  watch: {
    searchQuery() {
      this.applyFilters();
    },
  },
};
</script>
